import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useParams, useLocation, useHistory } from "react-router-dom";
import minusImage1 from "../../Images/minusImage1.png";
import plusImage1 from "../../Images/plusImage1.png";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import { useTranslation } from "react-i18next";
import Drawer from "@mui/material/Drawer";
import CloseImg from "../../Images/CloseImg.png";

import { MyDomain } from "../../App";

const FilterSection = React.memo(
  ({
    title,
    isOpen,
    toggleFilter,
    filterData,
    onChange,
    labelKey,
    countKey,
  }) => (
    <div
      style={{
        width: window.innerWidth <= 1024 ? "100%" : "80%",
        marginBottom: "16px",
        paddingLeft: "2%",
        paddingRight: "2%",
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: 10,
        }}
      >
        <p style={{ fontWeight: "600", margin: 0, fontSize: 16 }}>{title}</p>
        <img
          src={isOpen ? minusImage1 : plusImage1}
          alt={isOpen ? "Collapse" : "Expand"}
          style={{ width: 16, height: 16, cursor: "pointer" }}
          onClick={toggleFilter}
        />
      </div>

      {isOpen && (
        <div style={{ maxHeight: "250px", overflowY: "auto" }}>
          {[...filterData]
            .sort((a, b) =>
              a[labelKey]
                .toString()
                .localeCompare(b[labelKey].toString(), "en", {
                  sensitivity: "base",
                })
            )
            .map((item) => (
              <div
                key={item.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                  cursor: "pointer",
                }}
                onClick={() => onChange(item.id)}
              >
                <Checkbox
                  icon={
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        border: "1.4px solid #a3a3a3",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 1,
                      }}
                    />
                  }
                  checkedIcon={
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        border: "1.4px solid #a3a3a3",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 1,
                      }}
                    >
                      <Box
                        sx={{ width: 8, height: 8, backgroundColor: "black" }}
                      />
                    </Box>
                  }
                  checked={item.checked}
                  onChange={() => onChange(item.id)}
                  sx={{ padding: 0 }}
                />
                <span style={{ fontSize: 13 }}>
                  {item[labelKey]} ({item[countKey]})
                </span>
              </div>
            ))}
        </div>
      )}
    </div>
  )
);

export default function AllCategoriesFiltersNew({
  onSendData,
  setProductsDataWithoutDub,
  setLoading,
  setProductsData,
  onToggle,
  MyBrandsFilter,
  open3,
  setOpen3,
  sendDataToParent,
  dataFromChild,
  onButtonClick,
  data,
  content,
  showContent,
  clearAll,
  sendPricingToParent,
  delPricing,
}) {
  const { CategoryName } = useParams();
  const { t, i18n } = useTranslation();
  const [ShowApply, setShowApply] = useState(false);
  // Function to handle toggling or setting the `open` state from the child
  const handleToggleFromChild = (value) => {
    ShowApplyFunc(false);
    if (typeof value === "boolean") {
      setOpen3(value); // Set the state to the provided value (true or false)
    } else {
      //setOpen3((prevOpen) => !prevOpen); // Toggle the state if no value is provided
      setOpen3((prevOpen) => !prevOpen); // Toggle the state if no value is provided
    }
  };

  const ShowApplyFunc = (value) => {
    setShowApply(value);
  };
  const [MyWidth, setMyWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [customMinPrice, setCustomMinPrice] = useState(""); // State for custom min price
  const [customMaxPrice, setCustomMaxPrice] = useState(""); // State for custom max price

  const priceRanges = [
    { label: `${t("profile.Less")} 50 ₪`, min: 0, max: 50 },
    { label: "50 - 100 ₪", min: 50, max: 100 },
    { label: "100 - 250 ₪", min: 100, max: 250 },
    { label: "250 - 500 ₪", min: 250, max: 500 },
    { label: "500 - 750 ₪", min: 500, max: 750 },
    { label: "750 - 1000 ₪", min: 750, max: 1000 },
    { label: "1000 - 5000 ₪", min: 1000, max: 5000 },
    { label: `${t("profile.Morethan")} 5000 ₪`, min: 5000, max: Infinity },
  ];

  // Category-specific filter visibility logic
  const ProductPropertiesArray = [
    ...Array.from({ length: 15 }, (v, i) => 8000 + i),
  ];
  const FindProductProperties = ProductPropertiesArray.find(
    (value) => value === Number(CategoryName)
  );

  const GenderArray = [
    ...Array.from({ length: 21 }, (v, i) => 6000 + i),
    ...Array.from({ length: 15 }, (v, i) => 8000 + i),
  ];
  const FindGender = GenderArray.find(
    (value) => value === Number(CategoryName)
  );

  const IngredientsArray = [
    ...Array.from({ length: 21 }, (v, i) => 6000 + i),
    ...Array.from({ length: 34 }, (v, i) => 7000 + i),
  ];
  const FindIngredients = IngredientsArray.find(
    (value) => value === Number(CategoryName)
  );

  const VolumeArray = [
    ...Array.from({ length: 7 }, (v, i) => 9000 + i),
    ...Array.from({ length: 15 }, (v, i) => 8000 + i),
  ];
  const FindVolume = VolumeArray.find(
    (value) => value === Number(CategoryName)
  );

  const MadeInArray = [...Array.from({ length: 15 }, (v, i) => 8000 + i)];
  const FindMadeIn = MadeInArray.find(
    (value) => value === Number(CategoryName)
  );

  const ColorArray = [
    ...Array.from({ length: 15 }, (v, i) => 8000 + i),
    ...Array.from({ length: 7 }, (v, i) => 9000 + i),
    ...Array.from({ length: 34 }, (v, i) => 7000 + i),
    ...Array.from({ length: 20 }, (v, i) => 1000 + i),
  ];
  const FindColor = ColorArray.find((value) => value === Number(CategoryName));

  const CountryArray = [
    ...Array.from({ length: 7 }, (v, i) => 9000 + i),
    ...Array.from({ length: 15 }, (v, i) => 8000 + i),
    ...Array.from({ length: 20 }, (v, i) => 1000 + i),
  ];
  const FindCountry = CountryArray.find(
    (value) => value === Number(CategoryName)
  );

  const ScentTypeArray = [...Array.from({ length: 20 }, (v, i) => 1000 + i)];
  const FindScentType = ScentTypeArray.find(
    (value) => value === Number(CategoryName)
  );

  const TopNoteArray = [
    ...Array.from({ length: 20 }, (v, i) => 1000 + i),
    ...Array.from({ length: 21 }, (v, i) => 6000 + i),
  ];
  const FindTopNote = TopNoteArray.find(
    (value) => value === Number(CategoryName)
  );

  const HeartNoteArray = [...Array.from({ length: 20 }, (v, i) => 1000 + i)];
  const FindHeartNote = HeartNoteArray.find(
    (value) => value === Number(CategoryName)
  );

  const BaseNoteArray = [...Array.from({ length: 20 }, (v, i) => 1000 + i)];
  const FindBaseNote = BaseNoteArray.find(
    (value) => value === Number(CategoryName)
  );

  const ProtectionLevelArray = [
    ...Array.from({ length: 55 }, (v, i) => 2000 + i),
  ];
  const FindProtectionLevel = ProtectionLevelArray.find(
    (value) => value === Number(CategoryName)
  );

  const EyeshadowEffectArray = [
    ...Array.from({ length: 55 }, (v, i) => 2000 + i),
  ];
  const FindEyeshadowEffect = EyeshadowEffectArray.find(
    (value) => value === Number(CategoryName)
  );

  const FormulaArray = [...Array.from({ length: 55 }, (v, i) => 2000 + i)];
  const FindFormula = FormulaArray.find(
    (value) => value === Number(CategoryName)
  );

  const HairTypeArray = [
    ...Array.from({ length: 42 }, (v, i) => 3000 + i),
    ...Array.from({ length: 34 }, (v, i) => 7000 + i),
  ];
  const FindHairType = HairTypeArray.find(
    (value) => value === Number(CategoryName)
  );

  const BrushMaterialArray = [
    ...Array.from({ length: 42 }, (v, i) => 3000 + i),
  ];
  const FindBrushMaterial = BrushMaterialArray.find(
    (value) => value === Number(CategoryName)
  );

  const SkinTypeArray = [
    ...Array.from({ length: 41 }, (v, i) => 4000 + i),
    ...Array.from({ length: 58 }, (v, i) => 5000 + i),
    ...Array.from({ length: 21 }, (v, i) => 6000 + i),
    ...Array.from({ length: 34 }, (v, i) => 7000 + i),
  ];
  const FindSkinType = SkinTypeArray.find(
    (value) => value === Number(CategoryName)
  );

  const AgeArray = [
    ...Array.from({ length: 34 }, (v, i) => 7000 + i),
    ...Array.from({ length: 7 }, (v, i) => 9000 + i),
  ];
  const FindAge = AgeArray.find((value) => value === Number(CategoryName));

  // Filter visibility states
  const [hideBrandFilter, setHideBrandFilter] = useState(true);
  const [hideGenderFilter, setHideGenderFilter] = useState(!FindGender);
  const [hideTopNoteFilter, setHideTopNoteFilter] = useState(!FindTopNote);
  const [hideProductTypeFilter, setHideProductTypeFilter] = useState(true);
  const [hideClassfication, setHideClassfication] = useState(false);
  const [hideProductProperties, setHideProductProperties] = useState(
    !FindProductProperties
  );
  const [hideScentType, setHideScentType] = useState(!FindScentType);
  const [hideHeartNote, setHideHeartNote] = useState(!FindHeartNote);
  const [hideBaseNote, setHideBaseNote] = useState(!FindBaseNote);
  const [hideIngredients, setHideIngredients] = useState(!FindIngredients);
  const [hideSpecialCertificates, setHideSpecialCertificates] = useState(false);
  const [hideVolume, setHideVolume] = useState(!FindVolume);
  const [hideMadeIn, setHideMadeIn] = useState(!FindMadeIn);
  const [hideColor, setHideColor] = useState(!FindColor);
  const [hideProtectionLevel, setHideProtectionLevel] = useState(
    !FindProtectionLevel
  );
  const [hideEyeshadowEffect, setHideEyeshadowEffect] = useState(
    !FindEyeshadowEffect
  );
  const [hideFormula, setHideFormula] = useState(!FindFormula);
  const [hideCountry, setHideCountry] = useState(!FindCountry);
  const [hideHairType, setHideHairType] = useState(!FindHairType);
  const [hideBrushMaterial, setHideBrushMaterial] = useState(
    !FindBrushMaterial
  );
  const [hideSkinType, setHideSkinType] = useState(!FindSkinType);
  const [hideAge, setHideAge] = useState(!FindAge);
  const [hidePrice, setHidePrice] = useState(true);

  // Filter data states
  const [BrandsFilter, setBrandsFilter] = useState([]);
  const [GenderFilter, setGenderFilter] = useState([]);
  const [TopNoteFilter, setTopNoteFilter] = useState([]);
  const [ProductTypeFilter, setProductTypeFilter] = useState([]);
  const [ClassficationFilter, setClassficationFilter] = useState([]);
  const [ProductPropertiesFilter, setProductPropertiesFilter] = useState([]);
  const [ScentTypeFilter, setScentTypeFilter] = useState([]);
  const [HeartNoteFilter, setHeartNoteFilter] = useState([]);
  const [BaseNoteFilter, setBaseNoteFilter] = useState([]);
  const [IngredientsFilter, setIngredientsFilter] = useState([]);
  const [SpecialCertificatesFilter, setSpecialCertificatesFilter] = useState(
    []
  );
  const [VolumeFilter, setVolumeFilter] = useState([]);
  const [MadeInFilter, setMadeInFilter] = useState([]);
  const [ColorFilter, setColorFilter] = useState([]);
  const [ProtectionLevelFilter, setProtectionLevelFilter] = useState([]);
  const [EyeshadowEffectFilter, setEyeshadowEffectFilter] = useState([]);
  const [FormulaFilter, setFormulaFilter] = useState([]);
  const [CountryFilter, setCountryFilter] = useState([]);
  const [HairTypeFilter, setHairTypeFilter] = useState([]);
  const [BrushMaterialFilter, setBrushMaterialFilter] = useState([]);
  const [SkinTypeFilter, setSkinTypeFilter] = useState([]);
  const [AgeFilter, setAgeFilter] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const getQuery = () => new URLSearchParams(location.search);

  const getFilterValuesFromQuery = (key) => {
    const query = getQuery();
    const value = query.get(key);
    return value ? value.split(",") : [];
  };

  const groupByField = (array, key) => {
    const grouped = {};
    array.forEach((item) => {
      const values = item[key]?.split(",").map((v) => v.trim()) || [];
      values.forEach((val) => {
        if (val) {
          if (!grouped[val]) {
            grouped[val] = { id: val, [key]: val, times: 0 };
          }
          grouped[val].times += 1;
        }
      });
    });
    return Object.values(grouped).map((item, idx) => ({
      ...item,
      id: idx + 1,
      checked: false,
    }));
  };

  const updateCheckedStates = (filterArray, key, checkedValues) =>
    filterArray.map((item) => ({
      ...item,
      checked: checkedValues.includes(item[key]),
    }));

  const fetchAllProductsForFilters = async () => {
    setLoading(false); // start loading
    try {
      const response = await axios.get(
        `${MyDomain}Products/GetProductsByFilterCat`,
        {
          params: { codeCat: CategoryName },
        }
      );
      const products = response.data;

      // Update all filter states based on the products data
      const updateAllFilters = (products) => {
        // Brand filter
        const brandsInUrl = getFilterValuesFromQuery("brand");
        const fullBrandFilter = groupByField(products, "brand");
        setBrandsFilter(
          updateCheckedStates(fullBrandFilter, "brand", brandsInUrl)
        );

        // Gender filter
        const gendersInUrl = getFilterValuesFromQuery("gender");
        const fullGenderFilter = groupByField(products, "gender");
        setGenderFilter(
          updateCheckedStates(fullGenderFilter, "gender", gendersInUrl)
        );

        // Product Type filter
        const productTypeInUrl = getFilterValuesFromQuery("productType");
        const fullproductTypeFilter = groupByField(products, "productType");
        setProductTypeFilter(
          updateCheckedStates(
            fullproductTypeFilter,
            "productType",
            productTypeInUrl
          )
        );

        // Top Note filter
        const topNoteInUrl = getFilterValuesFromQuery("topNote");
        const fullTopNoteFilter = groupByField(products, "topNote");
        setTopNoteFilter(
          updateCheckedStates(fullTopNoteFilter, "topNote", topNoteInUrl)
        );

        // Classification filter
        const classificationInUrl = getFilterValuesFromQuery("classification");
        const fullClassificationFilter = groupByField(
          products,
          "classification"
        );
        setClassficationFilter(
          updateCheckedStates(
            fullClassificationFilter,
            "classification",
            classificationInUrl
          )
        );

        // Product Properties filter
        const productPropertiesInUrl =
          getFilterValuesFromQuery("productProperties");
        const fullProductPropertiesFilter = groupByField(
          products,
          "productProperties"
        );
        setProductPropertiesFilter(
          updateCheckedStates(
            fullProductPropertiesFilter,
            "productProperties",
            productPropertiesInUrl
          )
        );

        // Scent Type filter
        const scentTypeInUrl = getFilterValuesFromQuery("scentType");
        const fullScentTypeFilter = groupByField(products, "scentType");
        setScentTypeFilter(
          updateCheckedStates(fullScentTypeFilter, "scentType", scentTypeInUrl)
        );

        // Heart Note filter
        const heartNoteInUrl = getFilterValuesFromQuery("heartNote");
        const fullHeartNoteFilter = groupByField(products, "heartNote");
        setHeartNoteFilter(
          updateCheckedStates(fullHeartNoteFilter, "heartNote", heartNoteInUrl)
        );

        // Base Note filter
        const baseNoteInUrl = getFilterValuesFromQuery("baseNote");
        const fullBaseNoteFilter = groupByField(products, "baseNote");
        setBaseNoteFilter(
          updateCheckedStates(fullBaseNoteFilter, "baseNote", baseNoteInUrl)
        );

        // Ingredients filter
        const ingredientsInUrl = getFilterValuesFromQuery("ingredients");
        const fullIngredientsFilter = groupByField(products, "ingredients");
        setIngredientsFilter(
          updateCheckedStates(
            fullIngredientsFilter,
            "ingredients",
            ingredientsInUrl
          )
        );

        // Special Certificates filter
        const specialCertificatesInUrl = getFilterValuesFromQuery(
          "specialCertificates"
        );
        const fullSpecialCertificatesFilter = groupByField(
          products,
          "specialCertificates"
        );
        setSpecialCertificatesFilter(
          updateCheckedStates(
            fullSpecialCertificatesFilter,
            "specialCertificates",
            specialCertificatesInUrl
          )
        );

        // Volume filter
        const volumeInUrl = getFilterValuesFromQuery("volume");
        const fullVolumeFilter = groupByField(products, "volume");
        setVolumeFilter(
          updateCheckedStates(fullVolumeFilter, "volume", volumeInUrl)
        );

        // Made In filter
        const madeInInUrl = getFilterValuesFromQuery("madeIn");
        const fullMadeInFilter = groupByField(products, "madeIn");
        setMadeInFilter(
          updateCheckedStates(fullMadeInFilter, "madeIn", madeInInUrl)
        );

        // Color filter
        const colorInUrl = getFilterValuesFromQuery("color");
        const fullColorFilter = groupByField(products, "color");
        setColorFilter(
          updateCheckedStates(fullColorFilter, "color", colorInUrl)
        );

        // Protection Level filter
        const protectionLevelInUrl =
          getFilterValuesFromQuery("protectionLevel");
        const fullProtectionLevelFilter = groupByField(
          products,
          "protectionLevel"
        );
        setProtectionLevelFilter(
          updateCheckedStates(
            fullProtectionLevelFilter,
            "protectionLevel",
            protectionLevelInUrl
          )
        );

        // Eyeshadow Effect filter
        const eyeshadowEffectInUrl =
          getFilterValuesFromQuery("eyeshadowEffect");
        const fullEyeshadowEffectFilter = groupByField(
          products,
          "eyeshadowEffect"
        );
        setEyeshadowEffectFilter(
          updateCheckedStates(
            fullEyeshadowEffectFilter,
            "eyeshadowEffect",
            eyeshadowEffectInUrl
          )
        );

        // Formula filter
        const formulaInUrl = getFilterValuesFromQuery("formula");
        const fullFormulaFilter = groupByField(products, "formula");
        setFormulaFilter(
          updateCheckedStates(fullFormulaFilter, "formula", formulaInUrl)
        );

        // Country filter
        const countryInUrl = getFilterValuesFromQuery("country");
        const fullCountryFilter = groupByField(products, "country");
        setCountryFilter(
          updateCheckedStates(fullCountryFilter, "country", countryInUrl)
        );

        // Hair Type filter
        const hairTypeInUrl = getFilterValuesFromQuery("hairType");
        const fullHairTypeFilter = groupByField(products, "hairType");
        setHairTypeFilter(
          updateCheckedStates(fullHairTypeFilter, "hairType", hairTypeInUrl)
        );

        // Brush Material filter
        const brushMaterialInUrl = getFilterValuesFromQuery("brushMaterial");
        const fullBrushMaterialFilter = groupByField(products, "brushMaterial");
        setBrushMaterialFilter(
          updateCheckedStates(
            fullBrushMaterialFilter,
            "brushMaterial",
            brushMaterialInUrl
          )
        );

        // Skin Type filter
        const skinTypeInUrl = getFilterValuesFromQuery("skinType");
        const fullSkinTypeFilter = groupByField(products, "skinType");
        setSkinTypeFilter(
          updateCheckedStates(fullSkinTypeFilter, "skinType", skinTypeInUrl)
        );

        // Age filter
        const ageInUrl = getFilterValuesFromQuery("age");
        const fullAgeFilter = groupByField(products, "age");
        setAgeFilter(updateCheckedStates(fullAgeFilter, "age", ageInUrl));
      };

      updateAllFilters(products);
    } catch (error) {
      console.error("Error fetching all products for filters", error);
    } finally {
      setLoading(true); // end loading
    }
  };

  const fetchFilteredProducts = async () => {
    setIsLoading(true);

    try {
      const queryParams = {
        codeCat: CategoryName,
        brand: getFilterValuesFromQuery("brand").join(",") || undefined,
        gender: getFilterValuesFromQuery("gender").join(",") || undefined,
        productType:
          getFilterValuesFromQuery("productType").join(",") || undefined,
        topNote: getFilterValuesFromQuery("topNote").join(",") || undefined,
        classification:
          getFilterValuesFromQuery("classification").join(",") || undefined,
        productProperties:
          getFilterValuesFromQuery("productProperties").join(",") || undefined,
        scentType: getFilterValuesFromQuery("scentType").join(",") || undefined,
        heartNote: getFilterValuesFromQuery("heartNote").join(",") || undefined,
        baseNote: getFilterValuesFromQuery("baseNote").join(",") || undefined,
        ingredients:
          getFilterValuesFromQuery("ingredients").join(",") || undefined,
        specialCertificates:
          getFilterValuesFromQuery("specialCertificates").join(",") ||
          undefined,
        volume: getFilterValuesFromQuery("volume").join(",") || undefined,
        madeIn: getFilterValuesFromQuery("madeIn").join(",") || undefined,
        color: getFilterValuesFromQuery("color").join(",") || undefined,
        protectionLevel:
          getFilterValuesFromQuery("protectionLevel").join(",") || undefined,
        eyeshadowEffect:
          getFilterValuesFromQuery("eyeshadowEffect").join(",") || undefined,
        formula: getFilterValuesFromQuery("formula").join(",") || undefined,
        country: getFilterValuesFromQuery("country").join(",") || undefined,
        hairType: getFilterValuesFromQuery("hairType").join(",") || undefined,
        brushMaterial:
          getFilterValuesFromQuery("brushMaterial").join(",") || undefined,
        skinType: getFilterValuesFromQuery("skinType").join(",") || undefined,
        age: getFilterValuesFromQuery("age").join(",") || undefined,
        minPrice: getQuery().get("minPrice") || undefined,
        maxPrice: getQuery().get("maxPrice") || undefined,
      };

      // Remove undefined params
      Object.keys(queryParams).forEach(
        (key) => queryParams[key] === undefined && delete queryParams[key]
      );

      const response = await axios.get(
        `${MyDomain}Products/GetProductsByFilterCat`,
        { params: queryParams }
      );

      const newArray = response.data.filter(
        (item) => item.id === item.productId
      );
      setProductsData(response.data);
      setProductsDataWithoutDub(newArray);
      onSendData(newArray);
      setLoading(true);
    } catch (error) {
      console.error("Error fetching filtered products", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllProductsForFilters();
    fetchFilteredProducts();
  }, [CategoryName, location.search]);

  const handleCheckboxChange = (filterKey, id) => {
    console.log(filterKey);
    console.log(id);
    setShowApply(true);
    const filterMap = {
      BrandsFilter: {
        state: BrandsFilter,
        setter: setBrandsFilter,
        key: "brand",
      },
      GenderFilter: {
        state: GenderFilter,
        setter: setGenderFilter,
        key: "gender",
      },
      ProductTypeFilter: {
        state: ProductTypeFilter,
        setter: setProductTypeFilter,
        key: "productType",
      },
      ClassficationFilter: {
        state: ClassficationFilter,
        setter: setClassficationFilter,
        key: "classification",
      },
      ProductPropertiesFilter: {
        state: ProductPropertiesFilter,
        setter: setProductPropertiesFilter,
        key: "productProperties",
      },
      ScentTypeFilter: {
        state: ScentTypeFilter,
        setter: setScentTypeFilter,
        key: "scentType",
      },
      TopNoteFilter: {
        state: TopNoteFilter,
        setter: setTopNoteFilter,
        key: "topNote",
      },
      HeartNoteFilter: {
        state: HeartNoteFilter,
        setter: setHeartNoteFilter,
        key: "heartNote",
      },
      BaseNoteFilter: {
        state: BaseNoteFilter,
        setter: setBaseNoteFilter,
        key: "baseNote",
      },
      IngredientsFilter: {
        state: IngredientsFilter,
        setter: setIngredientsFilter,
        key: "ingredients",
      },
      SpecialCertificatesFilter: {
        state: SpecialCertificatesFilter,
        setter: setSpecialCertificatesFilter,
        key: "specialCertificates",
      },
      VolumeFilter: {
        state: VolumeFilter,
        setter: setVolumeFilter,
        key: "volume",
      },
      MadeInFilter: {
        state: MadeInFilter,
        setter: setMadeInFilter,
        key: "madeIn",
      },
      ColorFilter: { state: ColorFilter, setter: setColorFilter, key: "color" },
      ProtectionLevelFilter: {
        state: ProtectionLevelFilter,
        setter: setProtectionLevelFilter,
        key: "protectionLevel",
      },
      EyeshadowEffectFilter: {
        state: EyeshadowEffectFilter,
        setter: setEyeshadowEffectFilter,
        key: "eyeshadowEffect",
      },
      FormulaFilter: {
        state: FormulaFilter,
        setter: setFormulaFilter,
        key: "formula",
      },
      CountryFilter: {
        state: CountryFilter,
        setter: setCountryFilter,
        key: "country",
      },
      HairTypeFilter: {
        state: HairTypeFilter,
        setter: setHairTypeFilter,
        key: "hairType",
      },
      BrushMaterialFilter: {
        state: BrushMaterialFilter,
        setter: setBrushMaterialFilter,
        key: "brushMaterial",
      },
      SkinTypeFilter: {
        state: SkinTypeFilter,
        setter: setSkinTypeFilter,
        key: "skinType",
      },
      AgeFilter: { state: AgeFilter, setter: setAgeFilter, key: "age" },
    };

    const { state, setter, key } = filterMap[filterKey];

    const updatedFilterState = state.map((item) =>
      item.id === id ? { ...item, checked: !item.checked } : item
    );
    setter(updatedFilterState);

    // Build new query param values
    const selectedValues = updatedFilterState
      .filter((item) => item.checked)
      .map((item) => item[key]);

    const query = getQuery();
    if (selectedValues.length > 0) {
      query.set(key, selectedValues.join(","));
    } else {
      query.delete(key);
    }

    history.push({ search: query.toString() });
  };

  // Memoize filter arrays for performance
  const memoizedBrandsFilter = useMemo(() => BrandsFilter, [BrandsFilter]);
  const memoizedGenderFilter = useMemo(() => GenderFilter, [GenderFilter]);
  const memoizedProductTypeFilter = useMemo(
    () => ProductTypeFilter,
    [ProductTypeFilter]
  );
  const memoizedClassficationFilter = useMemo(
    () => ClassficationFilter,
    [ClassficationFilter]
  );
  const memoizedProductPropertiesFilter = useMemo(
    () => ProductPropertiesFilter,
    [ProductPropertiesFilter]
  );
  const memoizedScentTypeFilter = useMemo(
    () => ScentTypeFilter,
    [ScentTypeFilter]
  );
  const memoizedTopNoteFilter = useMemo(() => TopNoteFilter, [TopNoteFilter]);
  const memoizedHeartNoteFilter = useMemo(
    () => HeartNoteFilter,
    [HeartNoteFilter]
  );
  const memoizedBaseNoteFilter = useMemo(
    () => BaseNoteFilter,
    [BaseNoteFilter]
  );
  const memoizedIngredientsFilter = useMemo(
    () => IngredientsFilter,
    [IngredientsFilter]
  );
  const memoizedSpecialCertificatesFilter = useMemo(
    () => SpecialCertificatesFilter,
    [SpecialCertificatesFilter]
  );
  const memoizedVolumeFilter = useMemo(() => VolumeFilter, [VolumeFilter]);
  const memoizedMadeInFilter = useMemo(() => MadeInFilter, [MadeInFilter]);
  const memoizedColorFilter = useMemo(() => ColorFilter, [ColorFilter]);
  const memoizedProtectionLevelFilter = useMemo(
    () => ProtectionLevelFilter,
    [ProtectionLevelFilter]
  );
  const memoizedEyeshadowEffectFilter = useMemo(
    () => EyeshadowEffectFilter,
    [EyeshadowEffectFilter]
  );
  const memoizedFormulaFilter = useMemo(() => FormulaFilter, [FormulaFilter]);
  const memoizedCountryFilter = useMemo(() => CountryFilter, [CountryFilter]);
  const memoizedHairTypeFilter = useMemo(
    () => HairTypeFilter,
    [HairTypeFilter]
  );
  const memoizedBrushMaterialFilter = useMemo(
    () => BrushMaterialFilter,
    [BrushMaterialFilter]
  );
  const memoizedSkinTypeFilter = useMemo(
    () => SkinTypeFilter,
    [SkinTypeFilter]
  );
  const memoizedAgeFilter = useMemo(() => AgeFilter, [AgeFilter]);

  // Add these price filter handler functions
  const handlePriceRangeCheckboxChange = (range) => {
    // If clicking the already selected range, deselect it
    if (
      selectedPriceRange &&
      selectedPriceRange.min === range.min &&
      selectedPriceRange.max === range.max
    ) {
      setSelectedPriceRange(null);
      setCustomMinPrice("");
      setCustomMaxPrice("");

      const query = getQuery();
      query.delete("minPrice");
      query.delete("maxPrice");
      history.push({ search: query.toString() });
    } else {
      // Select the new range
      setSelectedPriceRange(range);
      setCustomMinPrice("");
      setCustomMaxPrice("");

      const query = getQuery();
      query.set("minPrice", range.min);
      if (range.max !== Infinity) {
        query.set("maxPrice", range.max);
      } else {
        query.delete("maxPrice");
      }
      history.push({ search: query.toString() });
    }
  };
  // Add these new state variables for price filtering
  const [selectedPriceRange, setSelectedPriceRange] = useState(null);

  const handleCustomPriceChange = (type, value) => {
    // Reset any selected predefined range when using custom inputs
    setSelectedPriceRange(null);

    if (type === "min") {
      setCustomMinPrice(value);

      const query = getQuery();
      if (value) {
        query.set("minPrice", value);
      } else {
        query.delete("minPrice");
      }
      history.push({ search: query.toString() });
    } else {
      setCustomMaxPrice(value);

      const query = getQuery();
      if (value) {
        query.set("maxPrice", value);
      } else {
        query.delete("maxPrice");
      }
      history.push({ search: query.toString() });
    }
  };
  // Add this useEffect to initialize price filters from URL
  useEffect(() => {
    const query = getQuery();
    const minPrice = query.get("minPrice");
    const maxPrice = query.get("maxPrice");

    if (minPrice || maxPrice) {
      // Check if it matches any predefined range
      const matchedRange = priceRanges.find((range) => {
        return (
          range.min.toString() === minPrice &&
          (maxPrice ? range.max?.toString() === maxPrice : range.max === null)
        );
      });

      if (matchedRange) {
        setSelectedPriceRange(matchedRange);
      } else {
        // It's a custom range
        setCustomMinPrice(minPrice || "");
        setCustomMaxPrice(maxPrice || "");
      }
    }
  }, [location.search]);
  const handleClearAll = () => {
    history.push({ search: "" }); // Clears all query parameters
  };
  const TheFilters = () => {
    return (
      <div
        style={{
          direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
        }}
      >
        <div
          style={{
            marginBottom: "16px",
          }}
        ></div>
        <FilterSection
          title={t("filters.Brand")}
          isOpen={hideBrandFilter}
          toggleFilter={() => setHideBrandFilter(!hideBrandFilter)}
          filterData={memoizedBrandsFilter}
          onChange={(id) => handleCheckboxChange("BrandsFilter", id)}
          labelKey="brand"
          countKey="times"
        />

        <FilterSection
          title={t("filters.ProductType")}
          isOpen={hideProductTypeFilter}
          toggleFilter={() => setHideProductTypeFilter(!hideProductTypeFilter)}
          filterData={memoizedProductTypeFilter}
          onChange={(id) => handleCheckboxChange("ProductTypeFilter", id)}
          labelKey="productType"
          countKey="times"
        />

        <FilterSection
          title={t("filters.Classification")}
          isOpen={hideClassfication}
          toggleFilter={() => setHideClassfication(!hideClassfication)}
          filterData={memoizedClassficationFilter}
          onChange={(id) => handleCheckboxChange("ClassficationFilter", id)}
          labelKey="classification"
          countKey="times"
        />
        {FindProductProperties ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.ProductProperties")}
              isOpen={hideProductProperties}
              toggleFilter={() =>
                setHideProductProperties(!hideProductProperties)
              }
              filterData={memoizedProductPropertiesFilter}
              onChange={(id) =>
                handleCheckboxChange("ProductPropertiesFilter", id)
              }
              labelKey="productProperties"
              countKey="times"
            />
          </>
        )}
        {FindGender ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.Gender")}
              isOpen={hideGenderFilter}
              toggleFilter={() => setHideGenderFilter(!hideGenderFilter)}
              filterData={memoizedGenderFilter}
              onChange={(id) => handleCheckboxChange("GenderFilter", id)}
              labelKey="gender"
              countKey="times"
            />
          </>
        )}
        {FindScentType ? (
          <>
            <FilterSection
              title={t("filters.ScentType")}
              isOpen={hideScentType}
              toggleFilter={() => setHideScentType(!hideScentType)}
              filterData={memoizedScentTypeFilter}
              onChange={(id) => handleCheckboxChange("ScentTypeFilter", id)}
              labelKey="scentType"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}

        {FindTopNote ? (
          <>
            <FilterSection
              title={t("filters.TopNote")}
              isOpen={hideTopNoteFilter}
              toggleFilter={() => setHideTopNoteFilter(!hideTopNoteFilter)}
              filterData={memoizedTopNoteFilter}
              onChange={(id) => handleCheckboxChange("TopNoteFilter", id)}
              labelKey="topNote"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}
        {FindHeartNote ? (
          <>
            <FilterSection
              title={t("filters.HeartNote")}
              isOpen={hideHeartNote}
              toggleFilter={() => setHideHeartNote(!hideHeartNote)}
              filterData={memoizedHeartNoteFilter}
              onChange={(id) => handleCheckboxChange("HeartNoteFilter", id)}
              labelKey="heartNote"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}

        {FindBaseNote ? (
          <>
            <FilterSection
              title={t("filters.BaseNote")}
              isOpen={hideBaseNote}
              toggleFilter={() => setHideBaseNote(!hideBaseNote)}
              filterData={memoizedBaseNoteFilter}
              onChange={(id) => handleCheckboxChange("BaseNoteFilter", id)}
              labelKey="baseNote"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}
        {FindIngredients ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.Ingredients")}
              isOpen={hideIngredients}
              toggleFilter={() => setHideIngredients(!hideIngredients)}
              filterData={memoizedIngredientsFilter}
              onChange={(id) => handleCheckboxChange("IngredientsFilter", id)}
              labelKey="ingredients"
              countKey="times"
            />
          </>
        )}

        <FilterSection
          title={t("filters.SpecialCertificates")}
          isOpen={hideSpecialCertificates}
          toggleFilter={() =>
            setHideSpecialCertificates(!hideSpecialCertificates)
          }
          filterData={memoizedSpecialCertificatesFilter}
          onChange={(id) =>
            handleCheckboxChange("SpecialCertificatesFilter", id)
          }
          labelKey="specialCertificates"
          countKey="times"
        />
        {FindVolume ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.Volume")}
              isOpen={hideVolume}
              toggleFilter={() => setHideVolume(!hideVolume)}
              filterData={memoizedVolumeFilter}
              onChange={(id) => handleCheckboxChange("VolumeFilter", id)}
              labelKey="volume"
              countKey="times"
            />
          </>
        )}
        {FindMadeIn ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.MadeIn")}
              isOpen={hideMadeIn}
              toggleFilter={() => setHideMadeIn(!hideMadeIn)}
              filterData={memoizedMadeInFilter}
              onChange={(id) => handleCheckboxChange("MadeInFilter", id)}
              labelKey="madeIn"
              countKey="times"
            />
          </>
        )}
        {FindColor ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.Color")}
              isOpen={hideColor}
              toggleFilter={() => setHideColor(!hideColor)}
              filterData={memoizedColorFilter}
              onChange={(id) => handleCheckboxChange("ColorFilter", id)}
              labelKey="color"
              countKey="times"
            />
          </>
        )}

        {FindProtectionLevel ? (
          <>
            <FilterSection
              title={t("filters.ProtectionLevel")}
              isOpen={hideProtectionLevel}
              toggleFilter={() => setHideProtectionLevel(!hideProtectionLevel)}
              filterData={memoizedProtectionLevelFilter}
              onChange={(id) =>
                handleCheckboxChange("ProtectionLevelFilter", id)
              }
              labelKey="protectionLevel"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}
        {FindEyeshadowEffect ? (
          <>
            <FilterSection
              title={t("filters.EyeshadowEffect")}
              isOpen={hideEyeshadowEffect}
              toggleFilter={() => setHideEyeshadowEffect(!hideEyeshadowEffect)}
              filterData={memoizedEyeshadowEffectFilter}
              onChange={(id) =>
                handleCheckboxChange("EyeshadowEffectFilter", id)
              }
              labelKey="eyeshadowEffect"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}
        {FindFormula ? (
          <>
            <FilterSection
              title={t("filters.Formula")}
              isOpen={hideFormula}
              toggleFilter={() => setHideFormula(!hideFormula)}
              filterData={memoizedFormulaFilter}
              onChange={(id) => handleCheckboxChange("FormulaFilter", id)}
              labelKey="formula"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}

        {FindCountry ? (
          <></>
        ) : (
          <>
            <FilterSection
              title={t("filters.Country")}
              isOpen={hideCountry}
              toggleFilter={() => setHideCountry(!hideCountry)}
              filterData={memoizedCountryFilter}
              onChange={(id) => handleCheckboxChange("CountryFilter", id)}
              labelKey="country"
              countKey="times"
            />
          </>
        )}

        {FindHairType ? (
          <>
            <FilterSection
              title={t("filters.HairType")}
              isOpen={hideHairType}
              toggleFilter={() => setHideHairType(!hideHairType)}
              filterData={memoizedHairTypeFilter}
              onChange={(id) => handleCheckboxChange("HairTypeFilter", id)}
              labelKey="hairType"
              countKey="times"
            />{" "}
          </>
        ) : (
          <></>
        )}
        {FindBrushMaterial ? (
          <>
            <FilterSection
              title={t("filters.BrushMaterial")}
              isOpen={hideBrushMaterial}
              toggleFilter={() => setHideBrushMaterial(!hideBrushMaterial)}
              filterData={memoizedBrushMaterialFilter}
              onChange={(id) => handleCheckboxChange("BrushMaterialFilter", id)}
              labelKey="brushMaterial"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}

        {FindSkinType ? (
          <>
            <FilterSection
              title={t("filters.SkinType")}
              isOpen={hideSkinType}
              toggleFilter={() => setHideSkinType(!hideSkinType)}
              filterData={memoizedSkinTypeFilter}
              onChange={(id) => handleCheckboxChange("SkinTypeFilter", id)}
              labelKey="skinType"
              countKey="times"
            />
          </>
        ) : (
          <></>
        )}
        {FindAge ? (
          <>
            <FilterSection
              title={t("filters.Age")}
              isOpen={hideAge}
              toggleFilter={() => setHideAge(!hideAge)}
              filterData={memoizedAgeFilter}
              onChange={(id) => handleCheckboxChange("AgeFilter", id)}
              labelKey="age"
              countKey="times"
            />{" "}
          </>
        ) : (
          <></>
        )}

        <div>
          {/* ... all your existing FilterSections ... */}

          {/* Add this Price Filter section */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingBottom: 10,
              width: MyWidth <= 1024 ? "100%" : "80%",
              paddingLeft: "2%",
              paddingRight: "2%",
            }}
          >
            <p style={{ fontWeight: "600", margin: 0, fontSize: 16 }}>
              {t("filters.PriceRanges")}
            </p>
            <img
              src={hidePrice ? minusImage1 : plusImage1}
              alt={hidePrice ? "Collapse" : "Expand"}
              style={{ width: 16, height: 16, cursor: "pointer" }}
              onClick={() => {
                setHidePrice(!hidePrice);
              }}
            />
          </div>
          {hidePrice ? (
            <div
              style={{
                width: MyWidth <= 1024 ? "100%" : "80%",
                paddingLeft: "2%",
                paddingRight: "2%",
                marginBottom: "16px",
              }}
            >
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {priceRanges.map((range, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      width: "50%",
                      boxSizing: "border-box",
                      cursor: "pointer",
                      paddingBottom: 10,
                      alignItems: "center",
                    }}
                    onClick={() => handlePriceRangeCheckboxChange(range)}
                  >
                    <Checkbox
                      icon={
                        <Box
                          sx={{
                            width: 16,
                            height: 16,
                            border: "1.4px solid #a3a3a3",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 1,
                          }}
                        />
                      }
                      checkedIcon={
                        <Box
                          sx={{
                            width: 16,
                            height: 16,
                            border: "1.4px solid #a3a3a3",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 1,
                          }}
                        >
                          <Box
                            sx={{
                              width: 8,
                              height: 8,
                              backgroundColor: "black",
                            }}
                          />
                        </Box>
                      }
                      checked={
                        selectedPriceRange?.min === range.min &&
                        selectedPriceRange?.max === range.max
                      }
                      sx={{ padding: 0 }}
                    />
                    <span style={{ fontSize: 13 }}>{range.label}</span>
                  </div>
                ))}
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    width: "80%",
                    flexDirection: "column",
                    marginTop: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <a style={{ fontSize: 14 }}>{t("profile.From")}</a>
                    <input
                      style={{
                        width: "30%",
                        margin: 0,
                        border: "1px solid #d4d4d4",
                        height: 35,
                      }}
                      type="number"
                      value={customMinPrice}
                      onChange={(e) =>
                        handleCustomPriceChange("min", e.target.value)
                      }
                    />
                    <a style={{ fontSize: 14 }}>{t("profile.To")}</a>
                    <input
                      style={{
                        width: "30%",
                        margin: 0,
                        border: "1px solid #d4d4d4",
                        height: 35,
                      }}
                      type="number"
                      value={customMaxPrice}
                      onChange={(e) =>
                        handleCustomPriceChange("max", e.target.value)
                      }
                    />
                    <a style={{ fontSize: 20 }}>₪</a>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  };
  if (MyWidth <= 1024) {
    return (
      <div>
        {/* <Button onClick={toggleDrawer(true)}>Open drawer</Button> */}
        <Drawer
          open={open3}
          //onClose={handleToggleFromChild(false)}
          PaperProps={{
            sx: { width: "100%" }, // Ensures full width and height
          }}
        >
          <div
            style={{
              paddingLeft: "2%",
              paddingRight: "2%",
              display: "flex",
              justifyContent: "space-between",
              paddingTop: 20,
            }}
          >
            <a style={{ fontSize: 20, fontWeight: "500" }}>Filters</a>
            <div style={{}} onClick={() => handleToggleFromChild(false)}>
              <img
                src={CloseImg}
                alt={"Expand"}
                style={{ width: 25, height: 25, cursor: "pointer" }}
              />
            </div>
          </div>
          {TheFilters()}
          {ShowApply ? (
            <div
              style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                width: "100%",
                color: "white",
                textAlign: "center",
                padding: "10px",
                zIndex: 1000, // Ensure it stays on top of other content

                backgroundColor: "white",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingLeft: "2%",
                  paddingRight: "2%",
                }}
              >
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "white",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "49%",
                    minWidth: 180,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    border: "1px solid black",
                  }}
                  onClick={() => {
                    handleClearAll();
                    //ClearButton();
                    handleToggleFromChild(false);
                  }}
                >
                  <a style={{ fontSize: 14, color: "black" }}>
                    {t("profile.Clear")}
                  </a>
                </button>
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "49%",
                    minWidth: 180,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                  }}
                  onClick={() => {
                    handleToggleFromChild(false);
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.Apply")}</a>
                </button>
              </div>
            </div>
          ) : (
            <></>
          )}
        </Drawer>
      </div>
    );
  } else {
    return <div>{TheFilters()}</div>;
  }
}
